/* eslint-disable complexity */
var drupal = Drupal || {};
var settings = drupal.settings || {};

(function ($, ELCHistory) {
  function getURLParameter(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
  }
  var draggingInProgress = false;
  var section_param_filter = $('.js-filter-clear').text() ? $('.js-filter-clear').text() : 'All';
  var isMobileLayout = (function () {
    return Unison.fetch.now().name !== 'large' && Unison.fetch.now().name !== 'xlarge';
  })();
  var contentFilterPage = {
    queryParams: {
      filter: section_param_filter,
      sort: false,
      secondaryFilterSelector: false,
      currentPage: 1
    },
    lastSort: false,
    results: {
      resultsPerPage: 10,
      $elements: false,
      $allFilteredElements: false,
      $renderedResults: false,
      resultsArray: [],
      $grid: false,
      $showMoreResultsButton: false,
      $noResults: false
    },
    $selectBox: $(),
    parseAndRenderURL: function ($module) {
      var self = this;
      var filterParam = getURLParameter('section');

      if (filterParam) {
        var sortParam = getURLParameter('sort').replace('_', ' ');
        var $filter = (function () {
          filterParam = filterParam.replace('_', ' ');
          // Loop through all the button filters and match them to the URL params.
          // CSS4 supports case insensitive selectors for attributes, CSS3 doesn't.
          // We loop through the few filters, get the name attribute, and check it against the filterParams.
          var $found = $();

          $('.js-content-filter-set-filter-button', $module).each(function () {
            if (!$found.length && $(this).attr('name') && $(this).attr('name').trim().toLowerCase() === filterParam.toLowerCase()) {
              $found = $(this);
            }
          });

          return $found;
        })();

        if ($filter.length) {
          if (sortParam) {
            self.$selectBox.val(sortParam);
            self.$selectBox.selectBox('value', sortParam);
            this.queryParams.sort = self.$selectBox.val();
          }
          this.activateFilterUI($filter);
          this.activateFilter($filter.text().trim());
        } else {
          // Invalid URL params
          this.updateURL();
        }
      }
    },

    // Establish the URL to redirect to based on active queryParams.
    updateURL: function () {
      var generatedURL = '';

      if (this.queryParams.filter.length) {
        generatedURL += 'section=' + this.sanitizedFilter(this.queryParams.filter);
      }
      if (this.queryParams.sort) {
        generatedURL += '&sort=' + this.queryParams.sort;
      }
      if (this.queryParams.secondaryFilterSelector) {
        generatedURL += $(document).triggerHandler('contentFilter.passSecondaryFiltersIntoUrl');
      }
      if (generatedURL) {
        this.render(true);
        ELCHistory.replaceState(null, null, '?' + generatedURL);
      }
    },
    init: function ($module) {
      var self = this;
      var $filters = $('.js-content-filters', $module);
      var $secondaryFilters = $('.js-content-filter-set--v1', $module);
      var $elements = $('.js-content-filter-tout', $module);
      var primaryFilters = $module.data('filters');
      var allSecondaryFilters = [];
      var allFilterName = $('.js-filter-clear', $module).text().length ? $('.js-filter-clear', $module).text().trim() : self.queryParams.filter;

      self.$selectBox = $('.js-content-sort', $module);
      self.$selectBox.selectBox();
      this.queryParams.sort = self.$selectBox.val();
      this.results.resultsPerPage = $module.data('results-count') && parseInt($module.data('results-count')) > 0 ? parseInt($module.data('results-count')) : self.results.resultsPerPage;
      this.results.$showMoreResultsButton = $('.js-content-filter-more', $module);
      this.results.$noResults = $('.js-content-filter-no-results', $module);
      // Add CSS class for setup
      $elements.filter('.js-content-filter-tout--tip').parent().addClass('js-result-full result-full');
      // Split content formatter data attribute and create tags
      if (primaryFilters) {
        primaryFilters.split(',').forEach(function (filter) {
          $filters.append('<li><button name="' + filter + '" class="js-content-filter-set-filter-button content-filter-set-formatter__button">' + filter + '</button></li>');
        });
        self.toggleFilterWrappingSlashUI($filters.children());
        $(window).on('resize.filterSlashUI', _.debounce(function () {
          self.toggleFilterWrappingSlashUI($filters.children());
        }, 1000));
      }
      $elements.addClass('js-filter--' + self.sanitizedFilter(allFilterName).toLowerCase());
      $elements.each(function () {
        var $elem = $(this);
        var setIndex = 0;
        var allFilters = $elem.data('filters');
        var secondaryFilters = $elem.data('secondary-filters');

        if (allFilters) {
          allFilters.split(',').forEach(function (filter) {
            $elem.addClass('js-filter--' + self.sanitizedFilter(filter).toLowerCase());
          });
        }
        /*
        * Secondary Filters
        * There are multiple secondary filter sets, delimited by "|".
        * Each set can contain multiple filters separated by * ",".
        */
        if (secondaryFilters) {
          secondaryFilters.split('|').forEach(function (secondaryFilterSet) {
            if (!allSecondaryFilters[setIndex]) {
              allSecondaryFilters[setIndex] = [];
            }
            secondaryFilterSet.split(',').forEach(function (filter) {
              var trimmedFilter = filter.trim();
              var selector = 'js-secondary-filter-' + setIndex + '--' + self.sanitizedFilter(filter).toLowerCase();

              if (trimmedFilter.length) {
                allSecondaryFilters[setIndex][trimmedFilter] = selector;
                $elem.addClass(selector);
              }
            });
            setIndex++;
          });
        }
      });

      if (allSecondaryFilters.length) {
        $secondaryFilters.trigger('contentFilter.initSecondaryFilters', [allSecondaryFilters]).addClass('js-content-secondary-filter-init-fired');
        // Handles missed event due to async / defer
        $secondaryFilters.on('contentFilter.secondaryFiltersReady', function () {
          $secondaryFilters.trigger('contentFilter.initSecondaryFilters', [allSecondaryFilters]);
        });
      }

      // Create results object
      self.results.$grid = $('.js-content-filter-grid', $module);
      self.results.$elements = $elements;
      $elements.parent().detach();

      // Event Listeners
      $('body').on('touchstart', function () {
        draggingInProgress = false;
      }).on('touchmove', function () {
        draggingInProgress = true;
      }).on('touchend', function () {
        draggingInProgress = false;
      });
      $('.js-content-filter-set-filter-button', $filters).off('click.activate touchend.activate').on('click.activate touchend.activate', function () {
        if (isMobileLayout && draggingInProgress) {
          return false;
        }
        self.activateFilterUI($(this));
        self.activateFilter($(this).text().trim());
        if (allSecondaryFilters.length > 0) {
          $(document).trigger('contentFilter.initSecondaryFilters', [allSecondaryFilters]);
        }
      });

      self.$selectBox.off('change.activate').on('change.activate', function () {
        self.queryParams.sort = $(this).val();
        self.queryParams.currentPage = 1;
        self.updateURL();
      });

      $(document).on('contentBlock.secondaryFilter', function (event, data) {
        self.queryParams.currentPage = 1;
        if (data.length) {
          self.queryParams.secondaryFilterSelector = data;
        } else {
          self.queryParams.secondaryFilterSelector = false;
        }
        self.updateURL();
        self.render(self.queryParams.secondaryFilterSelector === false);
      });

      // If this page is being loaded with preset parameters
      if (getURLParameter('section')) {
        this.parseAndRenderURL($module);
      } else {
        this.updateURL();
      }
    },

    toggleFilterWrappingSlashUI: function ($filters) {
      var $prior = $filters.first();
      var lastOffset = $prior.offset().top;

      $filters.filter('.no-slash').removeClass('no-slash');
      $filters.each(function () {
        if ($(this).offset().top > lastOffset) {
          lastOffset = $(this).offset().top;
          $prior.addClass('no-slash');
        }
        $prior = $(this);
      });
    },

    sanitizedFilter: function (str) {
      if (settings.ru_character_check) {
        return str.replace(/ /g, '_').trim();
      }

      return str.replace(/[^A-Z0-9]/ig, '_').trim();
    },

    // Set variables related to filter
    activateFilter: function (filter) {
      this.queryParams.filter = filter;
      this.queryParams.secondaryFilterSelector = false;
      this.queryParams.currentPage = 1;

      this.updateURL();
      $(document).trigger('contentFilter.secondaryFilterReset');
    },

    // UI Related actions to activateFilter
    activateFilterUI: function ($filter) {
      var $filters = $filter.closest('.js-content-filters');

      $filters.find('button.active').removeClass('active');
      $filter.addClass('active');
    },

    animateResult: function ($element, animationTime) {
      setTimeout(function () {
        $element.addClass('result-visible');
      }, animationTime);
    },

    removeResults: function ($elements, animationTime) {
      $elements.removeClass('result-visible');
      setTimeout(function () {
        $elements.addClass('result-hidden');
      }, animationTime);
    },

    /*
    * Find all primary filter results and set $allFilteredElements.
    */
    hardRender: function () {
      var self = this;
      var index = 1;
      var pendingElementsArray = [];

      self.lastSort = self.queryParams.sort;
      // Reset HTML / result collections
      self.results.$grid.html('');
      self.results.resultsArray = [];

      // All the results in this category
      self.results.$elements.filter('.js-filter--' + self.sanitizedFilter(self.queryParams.filter.toLowerCase())).each(function () {
        // We can only reverse arrays
        self.results.resultsArray.push($(this).parent());
      });
      if (self.queryParams.sort === 'latest-first') {
        self.results.resultsArray.reverse();
      }
      // Append a cloned result
      self.results.resultsArray.forEach(function ($item) {
        var isFullWidthResult = $item.hasClass('js-result-full');

        if (!isMobileLayout) {
          self.results.$grid.append($item.clone());
        } else {
          /*
          * This block rearranges the output so that a pro tip card always takes full width.
          * We must also avoid leaving a dangling How To tout with an empty space next to it
          * because this happened.
          *
          */
          if (isFullWidthResult) {
            if (index % 2 !== 0) {
              self.results.$grid.append($item.clone());
            } else {
              pendingElementsArray.push($item.clone());
            }
          } else {
            self.results.$grid.append($item.clone());
            if (index % 2 === 0 && pendingElementsArray.length) {
              self.results.$grid.append(pendingElementsArray.shift());
            }
            index++;
          }
        }
      });
      if (isMobileLayout && pendingElementsArray.length) {
        self.results.$grid.append(pendingElementsArray);
      }
      // Save new results
      self.results.$renderedResults = self.results.$allFilteredElements = $('.js-content-filter-tout', self.results.$grid);
      $(document).trigger('clickableBlocks.reattach', [self.results.$renderedResults]);
      $(document).trigger('videos.reattach', [self.results.$renderedResults]);
    },

    /*
    * Determine to re-render or animate results.
    */
    render: function (forceHardRender, context) {
      var self = this;
      var $unusedToutParents = $();
      var sliceFrom = self.results.resultsPerPage * (self.queryParams.currentPage - 1);
      var sliceTo = self.results.resultsPerPage * self.queryParams.currentPage;
      var $elementsToRemove = $();
      var $elementsToSlice = $();
      var $lastChild = $();
      var $beforeLastChild = $();
      var lastSlice = false;
      var $contentFormatter = $('.content-formatter__rendered', context);

      if (forceHardRender) {
        self.hardRender();
      }
      /*
      * Filter primary filters with secondary filters.
      */
      if (self.queryParams.secondaryFilterSelector) {
        // All visible results from filter combinations
        var secondaryResult = self.queryParams.secondaryFilterSelector.replace(/,/g, '');

        self.results.$renderedResults = self.results.$allFilteredElements.filter(secondaryResult);
        if (self.results.$renderedResults.length < 1) {
          $contentFormatter.addClass('result-hidden').removeClass('result-visible');
        }
      }
      $unusedToutParents = $('.js-content-filter-tout', self.results.$grid).not(self.results.$renderedResults).parent();
      $(document).trigger('contentFilter.filtered', [self.results.$allFilteredElements]);

      // Determine if any results exist
      if (self.results.$renderedResults.length) {
        self.results.$noResults.parent().addClass('hidden');
      } else {
        self.results.$noResults.parent().removeClass('hidden');
      }

      /*
      * Pagination
      */
      // Show the "page" by splicing all results created
      if (sliceTo < self.results.$renderedResults.length) {
        self.results.$showMoreResultsButton.parent().removeClass('hidden');
      } else {
        self.results.$showMoreResultsButton.parent().addClass('hidden');
        lastSlice = true;
      }

      if (self.results.$renderedResults.length) {
        // Change how many are shown in mobile so that nothing is as a widow.
        // If the previous item was full width, make the element after last the new last to avoid empty space in a 2 column row.
        $elementsToSlice = self.results.$renderedResults.slice(sliceFrom, sliceTo);
        if (isMobileLayout) {
          $lastChild = $elementsToSlice.last().parent();
          $beforeLastChild = $lastChild.prev();
          // Remove the hidden so we can measure the offset
          $elementsToSlice.parent().removeClass('result-hidden');
          if ($beforeLastChild.length && $beforeLastChild.offset().top !== $lastChild.offset().top && !$lastChild.hasClass('js-result-full') && !lastSlice) {
            sliceTo++;
          }
        }
        // count here when pro tip are displayed
        $elementsToRemove = self.results.$renderedResults.parent().slice(sliceTo);
        /*
        * Remove unfiltered results.
        */
        self.removeResults($unusedToutParents, 300);
        self.removeResults($elementsToRemove, 0);

        $elementsToSlice = self.results.$renderedResults.slice(sliceFrom, sliceTo);
        $elementsToSlice.parent().each(function (index) {
          var $elem = $(this);

          $elem.removeClass('result-hidden');
          self.animateResult($elem, index * 75);
        });
      }
      self.results.$showMoreResultsButton.off('click.nextPage').on('click.nextPage', function () {
        self.queryParams.currentPage++;
        self.render();
      });
    }
  };
  /*
  * Go through each node ref'd tout, insert it before the noderef result DIV,
  * and then remove the noderef'd result DIV.
  * This is a workaround to deal with all the excessive wrappers from a noderef.
  */
  var $module = $('.js-content-filter-set-formatter--v1', document);
  var $unwrapNodeRefs = $('.js-content-formatter-rendered > .block-nodeblock, .js-content-formatter-rendered > div > .block-nodeblock', $module);

  $unwrapNodeRefs.each(function () {
    var $nodeBlock = $(this);
    var $rendered = $nodeBlock.closest('.js-content-formatter-rendered');
    var $touts = $('.js-content-filter-tout', $nodeBlock);

    $touts.each(function () {
      $(this).wrap('<div class="content-formatter__rendered result-hidden"></div>');
      $(this).parent().insertBefore($rendered);
    });
    $rendered.remove();
  });
  // Since this is a page with preprocessing, load before attachBehaviors
  contentFilterPage.init($module);
})(jQuery, window.ELCHistory || window.history);
